// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateLabel-module__label___5JWr-{display:block;margin:0 0 13px;text-align:center}
`, "",{"version":3,"sources":["webpack://./node_modules/mintel-react-ui/dist/package/DateLabel.css"],"names":[],"mappings":"AAAA,iCAAiC,aAAa,CAAC,eAAe,CAAC,iBAAiB","sourcesContent":[".DateLabel-module__label___5JWr-{display:block;margin:0 0 13px;text-align:center}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
